import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  completeOnboardingStep,
  dismissOnboarding,
  getOnboardingProgress,
  type OnboardingStepKey,
} from '../api/onboarding';

const QUERY_KEY = ['onboarding'] as const;

export function useOnboarding() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: getOnboardingProgress,
    staleTime: 60_000,
  });
}

export function useCompleteOnboardingStep() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (step: OnboardingStepKey) => completeOnboardingStep(step),
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY, data);
    },
  });
}

export function useDismissOnboarding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dismissOnboarding,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY, data);
    },
  });
}
